module.exports = __webpack_public_path__ + "static/media/noun_Delete_1234815.f2401b56.svg";